module.exports = __webpack_public_path__ + "6fbf955688c76632a3ef355c0b412506.svg";